import * as React from 'react';
import cx from 'classnames';
import { createSvgIcon } from '../utils/createSvgIcon';
import { iconClassNames } from '../utils/iconClassNames';

export const CameraIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg role="presentation" focusable="false" viewBox="2 2 16 16" className={classes.svg}>
      <g className={cx(iconClassNames.outline, classes.outlinePart)}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0002 6C7.79104 6 6.00018 7.79086 6.00018 10C6.00018 12.2091 7.79104 14 10.0002 14C12.2093 14 14.0002 12.2091 14.0002 10C14.0002 7.79086 12.2093 6 10.0002 6ZM7.00018 10C7.00018 8.34315 8.34333 7 10.0002 7C11.657 7 13.0002 8.34315 13.0002 10C13.0002 11.6569 11.657 13 10.0002 13C8.34333 13 7.00018 11.6569 7.00018 10Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.12412 1.99997C7.55707 1.99997 7.03849 2.31974 6.78386 2.8264L6.19437 3.99937H4.50488C3.12417 3.99937 2.00488 5.11865 2.00488 6.49937V14.5C2.00488 15.8807 3.12417 17 4.50488 17H15.5049C16.8856 17 18.0049 15.8807 18.0049 14.5V6.49937C18.0049 5.11866 16.8856 3.99937 15.5049 3.99937H13.8149L13.23 2.82927C12.976 2.32103 12.4565 1.99997 11.8883 1.99997H8.12412ZM7.67736 3.27545C7.76224 3.10656 7.9351 2.99997 8.12412 2.99997H11.8883C12.0777 2.99997 12.2509 3.10699 12.3356 3.2764L13.0587 4.72293C13.1433 4.89235 13.3165 4.99937 13.5059 4.99937H15.5049C16.3333 4.99937 17.0049 5.67094 17.0049 6.49937V14.5C17.0049 15.3284 16.3333 16 15.5049 16H4.50488C3.67646 16 3.00488 15.3284 3.00488 14.5V6.49937C3.00488 5.67094 3.67646 4.99937 4.50488 4.99937H6.50268C6.69169 4.99937 6.86455 4.89278 6.94943 4.72389L7.67736 3.27545Z"
        />
      </g>
      <g className={cx(iconClassNames.filled, classes.filledPart)}>
        <path d="M7.00018 10C7.00018 8.34315 8.34333 7 10.0002 7C11.657 7 13.0002 8.34315 13.0002 10C13.0002 11.6569 11.657 13 10.0002 13C8.34333 13 7.00018 11.6569 7.00018 10Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.78386 2.82643C7.03849 2.31977 7.55707 2 8.12412 2H11.8883C12.4565 2 12.976 2.32106 13.23 2.8293L13.8149 3.9994H15.5049C16.8856 3.9994 18.0049 5.11869 18.0049 6.4994V14.5C18.0049 15.8807 16.8856 17 15.5049 17H4.50488C3.12417 17 2.00488 15.8807 2.00488 14.5V6.4994C2.00488 5.11868 3.12417 3.9994 4.50488 3.9994H6.19437L6.78386 2.82643ZM10.0002 6C7.79104 6 6.00018 7.79086 6.00018 10C6.00018 12.2091 7.79104 14 10.0002 14C12.2093 14 14.0002 12.2091 14.0002 10C14.0002 7.79086 12.2093 6 10.0002 6Z"
        />
      </g>
    </svg>
  ),
  displayName: 'CameraIcon',
});
